<template>
  <div class="invited_conpon_list">
    <div class="empty" v-if="_couponList.length == 0">
      <p>您还没有任何奖励哦～</p>
    </div>
    <template v-else>
      <div class="title">恭喜您，获得以下奖励</div>
      <div class="counpon_list">
        <CouponItem
          v-for="(item, index) in _couponList"
          :key="index"
          :data="item"
          :isShowToUseButton="isShowToUseButton"
          :isShowRuleBtn="isShowRule"
        ></CouponItem>
      </div>
      <div class="show_more" v-if="couponData.length > 5 && isListCollapsed">
        <a @click="showMore">
          <span>{{ sliceLen == couponData.length ? '收起' : '查看更多' }}</span>
          <img
            src="../../assets/images/arrow_down_up.png"
            :class="{ up: sliceLen !== couponData.length }"
          />
        </a>
      </div>
    </template>
  </div>
</template>

<script>
import { getUrlParam } from '@/utils';
import CouponItem from './CouponItem';
export default {
  data() {
    return {
      sliceLen: 5
    };
  },
  props: {
    couponData: Array,
    isListCollapsed: {
      type: Boolean,
      default: false
    },
    isShowToUseButton: {
      type: Boolean,
      default: false
    },
    isShowRule: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    _couponList() {
      return this.isListCollapsed
        ? this.couponData.slice(0, this.sliceLen)
        : this.couponData;
    }
  },
  components: {
    CouponItem
  },
  mounted() {
    this.eventLog();
  },
  methods: {
    getBusiness(value) {
      switch (Number(value)) {
        case 1:
          return '通用';
        case 2:
          return '搬家';
        case 3:
          return '大车';
        case 4:
          return '小车';
        case 5:
          return '零担物流';
        case 6:
          return '司机会员';
        case 7:
          return '企业货运';
        case 8:
          return '小拉';
        default:
          return '';
      }
    },
    eventLog() {
      try {
        if (!this._couponList.length) return;
        this.trackLog('奖励栏', true, {
          activity_business: this.getBusiness(getUrlParam('bl')),
          actEventType: 'invited_reward_expo'
        });
      } catch (err) {
        console.error(err);
      }
    },
    showMore() {
      if (this.sliceLen == this.couponData.length) {
        this.sliceLen = 5;
      } else {
        // let couponData = this.couponData.filter(i => i.businessType);
        // let businessLines = couponData.map(i =>
        //   this.getBusiness(i.businessType)
        // );
        // this.trackLog('查看更多', true, {
        //   coupon_business_line: businessLines.join(','),
        //   actEventType: 'invited_reward_click'
        // });
        this.sliceLen = this.couponData.length;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.invited_conpon_list {
  margin: 0px auto 57px auto;
  padding-bottom: 32px;
  .empty {
    margin-top: 30px;
    .fc;
    padding-top: 50px;
    padding-bottom: 50px;
    width: 702px;
    height: 168px;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.09);
    p {
      font-size: 30px;
      color: #8c8c8c;
    }
  }
  .fcc;
  .title {
    font-size: 36px;
    padding: 16px 0px 28px 0px;
    color: #fff;
    font-weight: 500;
    text-align: center;
  }
  .show_more {
    margin-top: 20px;
    color: #ffffff;
    font-size: 28px;
    text-align: center;
    a {
      color: #ffffff;
    }
    span {
      vertical-align: middle;
      margin-right: 12px;
    }
    img {
      display: inline-block;
      width: 18px;
      vertical-align: middle;
      &.up {
        transform: rotate(180deg);
      }
    }
  }
}
</style>
